<template lang="html">
	<div class="manager-track-report center-panel report">
		<md-content md-theme="white" v-loader-overlay="progress">
			<sort-table
				v-bind:columns="tableColumns" v-model="deals" v-on:refresh="getDeals" v-bind:per-page="perPage" 
				v-bind:total="dealsAmount" table-id="report" default-order="desc" default-sort="id"
				v-bind:showAddButton="false"
			>
			
				<template slot="first_freight" slot-scope="scope">
					<span class="no-break-text"> {{(scope.item.first_freight && scope.item.first_freight.traking_number) ? scope.item.first_freight.traking_number : 'Не установлен'}} </span>
				</template>

				<template slot="created_at" slot-scope="scope">
					<span class="no-break-text"> {{(scope.item.created_at && scope.item.created_at) ? moment(scope.item.created_at).format('DD MMM YYYY') : 'Не установлен'}} </span>
				</template>

				<template slot="payer" slot-scope="scope">
					<span v-if="scope.item.payer && scope.item.payer.name"> {{scope.item.payer.name}} </span>
					<span v-else> Не указан </span>
				</template>

				<template slot="recipient" slot-scope="scope">
					<span v-if="scope.item.recipient && scope.item.recipient.name"> {{scope.item.recipient.name}} </span>
					<span v-else> Не указан </span>
				</template>

				<template slot="bill" slot-scope="scope">
					<div v-if="scope.item.documents && scope.item.documents.length">
						<div v-if="hasDocs(scope.item, 'bill')"> Да </div>
						<div v-else> Нет </div>
					</div>
					<div v-if="!scope.item.documents || !scope.item.documents.length"> Нет </div>
				</template>

				<template slot="invoice" slot-scope="scope">
					<div v-if="scope.item.documents && scope.item.documents.length">
						<div v-if="hasDocs(scope.item, 'invoice')"> Да </div>
						<div v-else> Нет </div>
					</div>
					<div v-if="!scope.item.documents || !scope.item.documents.length"> Нет </div>
				</template>

				<template slot="assignment" slot-scope="scope">
					<div v-if="scope.item.documents && scope.item.documents.length"> 
						<div v-if="hasDocs(scope.item, 'assignment')"> Да </div>
						<div v-else> Нет </div>
					</div>
					<div v-if="!scope.item.documents || !scope.item.documents.length"> Нет </div>
				</template>

				<template slot="recepit" slot-scope="scope">
					<div v-if="scope.item.documents && scope.item.documents.length">
						<div v-if="hasDocs(scope.item, 'recepit')"> Да </div>
						<div v-else> Нет </div>
					</div>
					<div v-if="!scope.item.documents || !scope.item.documents.length"> Нет </div>
				</template>

				<template slot="act" slot-scope="scope">
					<div v-if="scope.item.documents && scope.item.documents.length">
						<div v-if="hasDocs(scope.item, 'act')"> Да </div>
						<div v-else> Нет </div>
					</div>
					<div v-if="!scope.item.documents || !scope.item.documents.length"> Нет </div>
				</template>

				<template slot="stock_note" slot-scope="scope">
					<div v-if="scope.item.documents && scope.item.documents.length">
						<div v-if="hasDocs(scope.item, 'stock_note')"> Да </div>
						<div v-else> Нет </div>
					</div>
					<div v-if="!scope.item.documents || !scope.item.documents.length"> Нет </div>
				</template>

				<template slot="route_list" slot-scope="scope">
					<div v-if="scope.item.documents && scope.item.documents.length">
						<div v-if="hasDocs(scope.item, 'route_list')"> Да </div>
						<div v-else> Нет </div>
					</div>
					<div v-if="!scope.item.documents || !scope.item.documents.length"> Нет </div>
				</template>
			</sort-table>
		</md-content>
	</div>
</template>
<script>
	import SortTable from "@/components/SortTable"
	import reportsMenu from './reports-menu';
	export default {
		components: {SortTable, reportsMenu},
		data() {
			return {
				tableColumns: [
					{label: 'ID',             field: 'id',            sortable: true },
					{label: 'Треккод',        field: 'first_freight', sortable: true },
					{label: 'Дата создания',  field: 'created_at',    sortable: true },
					{label: 'Плательщик',     field: 'payer',         sortable: false },
					{label: 'Получатель',     field: 'recipient',     sortable: false },
					{label: 'Реализация',     field: 'realisation',   sortable: false},
					
					
					{ label: 'Счёт',                    field: 'bill',       sortable: false },
					{ label: 'Счёт фактура',            field: 'invoice',    sortable: false },
					{ label: 'Поручение экспедитору',   field: 'assignment', sortable: false },
					{ label: 'Экспедиторская расписка', field: 'recepit',    sortable: false },
					{ label: 'Акт выполненных работ',   field: 'act',        sortable: false },
					{ label: 'Складская записка',       field: 'stock_note', sortable: false },
					{ label: 'Маршрутный лист',         field: 'route_list', sortable: false },
					{ label: '',         				field: 'actions', 	 sortable: false },
					
				],
				currentPage: 1,
				perPage: 50,
				filter: null,
				docs: {
					bill: 'Счёт',
					invoice: 'Счёт фактура',
					assignment: 'Поручение экспедитору',
					recepit: 'Экспедиторская расписка',
					act: 'Акт выполненных работ',
					stock_note: 'Складская записка',
					route_list: 'Маршрутный лист'
				}
			}
		},
		created() {
			this.$store.dispatch('deals/getStatuses');
			this.$store.commit('setTitle', 'Путевой отчет менеджера');
		},
		watch: {
			'$route.query.filter'(filter) {
				if (filter) this.filter = Object.assign({}, JSON.parse(filter));
				else this.filter = null;
				this.getDeals(this.currentPage, this.perPage, 'id', 'desc');
			}
		},
		computed: {
			/**
			 * Флаг загрузки текущего компонента
			 */
			progress() {
				return this.progressObj['get-deals-list'];
			},
			/**
			 * Объект флагов загрузки
			 */
			progressObj() {
				return this.$store.state.progressObj;
			},
			/**
			 * Список отчетов
			 */
			deals() {
				return this.$store.state.deals.deals
			},
			/**
			 * Количество отчетов-
			 */
			dealsAmount() {
				return this.$store.state.deals.deals_amount
			},
		},
		methods: {
			/**
			 * Получение заявок
			 */
			getDeals(page, count, orderBy, orderType) {
				this.$store.commit('showProgressBar', 'get-deals-list');
				let data = {
					page:       (page)      ? page      : 1, 
					order_by:   (orderBy)   ? orderBy   : 'id', 
					order_type: (orderType) ? orderType : 'desc',
					count:      (count)     ? count     : 50,
					filter:     (this.filter) ? this.filter : null 
				};
				this.$store.dispatch('deals/getDeals', data)
					.finally(() => this.$store.commit('hideProgressBar', 'get-deals-list'));
			},
			/**
			 * Проверка на наличие документов
			 */
			hasDocs(item, docType) {
				let result = false;
				if (!item.documents || !item.documents.length) return result;

				item.documents.map(doc => {
					if (doc.type == docType) result = true;
				});

				return result;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// MissingDocumentsReport.vue?00dbcafb